/* eslint-disable arrow-parens */
export default class AppModel {
    constructor(state) {
        this.state = state;
    }

    async getInfo() {
        const { url2 } = this.state;
        const responce = await fetch(url2);
        const data = await responce.json();
        return data;
    }

    async getId() {
        const { url } = this.state;
        const responce = await fetch(url);
        const data = await responce.json();
        return data.items.map((clip) => clip.id.videoId);
    }

    async getNextPage() {
        const { url } = this.state;
        const responce = await fetch(url);
        const data = await responce.json();
        return data.nextPageToken;
    }

    async getPrevPage() {
        const { url } = this.state;
        const responce = await fetch(url);
        const data = await responce.json();
        return data.prevPageToken;
    }
}
